import { useEffect, useState } from "react";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";

export const useDashboardHeader = () => {
  const [bookingSummary, setBookingSummary] = useState({
    completedUntilWeek: null,
    ongoingWeeks: [],
  });

  const loadOngoingBookingWeeks = async () => {
    const loadingWeekUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.deliveryInfoes}`;
    const findByKitchenUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.findByKitchen}`;

    const kitchenList = [
      "Nolte Kitchen Lacquered",
      "Nolte Kitchen Non Lacquered",
      "Nolte Eco Lacquered",
      "Nolte Eco Non Lacquered",
      "Nolte Neo Lacquered",
      "Nolte Neo Non Lacquered",
      "Nolte Spa Lacquered",
      "Nolte Spa Non Lacquered",
    ];

    const res = await OAuthService.getList(loadingWeekUrl);

    const deliveryInfoes =
      res?.data?._embedded?.deliveryInfoes?.filter(d =>
        kitchenList.includes(d.kitchenName)
      ) || [];

    if (!deliveryInfoes.length) return [];

    const model = {
      kitchenNames: deliveryInfoes.map(d => d.kitchenName),
      date: new Date(),
    };

    const weekRes = await OAuthService.addData(findByKitchenUrl, model);
    const weeks = weekRes?.data?.map(w => w.week) || [];

    return [...new Set(weeks)].sort((a, b) => a - b);
  };

  const loadContainerPlanData = async () => {
    const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}api/containerPlan/getLastBookingWeek`;
    const res = await OAuthService.getList(url);
    return res?.data;
  };

  useEffect(() => {
    let isMounted = true;

    const loadHeaderData = async () => {
      try {
        const [ongoingWeeksData, containerPlanData] = await Promise.all([
          loadOngoingBookingWeeks(),
          loadContainerPlanData()
        ]);

        if (isMounted) {
          setBookingSummary({
            ongoingWeeks: ongoingWeeksData,
            completedUntilWeek: containerPlanData ?? null,
          });
        }
      } catch (err) {
        console.error("Dashboard header failed", err);
      }
    };

    loadHeaderData();
    return () => (isMounted = false);
  }, []);

  return bookingSummary;
};
